export const BASE_phone_number = +919999999999;
export const BASE_email = "roma@mail.com";
export const BASE_URL = "http://127.0.0.1:8000";
export const CURRENCY = "د.أ";
export const FERTILIZER_UNIT = "كجم";
// export const FERTILIZER_UNIT = "كجم";
export const DATE_FORMAT = "DD/MM/YYYY";
